<template>
  <div id="bscdown1">
    <div class="box">
      <div id="bscdown1div" style="height:96%;width:96%;margin-top:10px"></div>
    </div>
  </div>
</template>

<script>
// 2：导入echarts
import echarts from 'echarts';
import { AREA_LIST, BU_LIST, MONTH_NAME } from '../mainPage/area_bu'

export default {
  name: 'bscdown',
  data() {
    return {
      // 需要合并对象，样式
      options: {},
      NowYearTargetValue: [],
      dataset: []
    };
  },
  created() {},
  mounted() {
    //   mounted 函数表示已经DOM渲染完成
    this.NowYearTargetValue = []
    MONTH_NAME.forEach(x => {
      this.NowYearTargetValue.push(x.label)
    })
  },
  methods: {
    refreshChart(chartData) {
      const data1 = []
      const data2 = []
      const data3 = []
      const titleData = []
      this.dataset = []
      if (chartData !== undefined) {
        for (let i = 0; i < chartData.length; i++) {
          titleData.push(chartData[i].DisplayName)
          data1.push(chartData[i].LastYearPracticalValue)
          data2.push(chartData[i].PracticalValue)
          data3.push(chartData[i].PlanValue)
          this.NowYear = chartData[i].Year
        }
      }
      this.dataset = [data2, data3]

      var myChart = echarts.init(document.getElementById('bscdown1div'));

      var option = {
        title: {
          text: this.locale('Energy Consumption','分月能耗汇总'),
          textStyle: {
            color: '#fff',
            fontSize: 24
          },
          left: 'center'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          x: 'right',
          y: 30,
          orient: 'vertical',
          textStyle: {
            color: '#ffffff',
            fontSize: 16
          },
          data: [
            this.locale('Actual','实际'),
            this.locale('Target','目标')
          ]
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: this.NowYearTargetValue,
            axisLabel: {
              interval: 0,
              color: '#ffffff',
              fontSize: 14
            },
            axisLine: {
              // 轴线
              lineStyle: {
                color: '#7f8fa4'
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: this.locale('tce','吨标煤'),
            nameTextStyle: {
              color: '#ffffff',
              fontSize: 16
            },
            boundaryGap: [0, '10%'],
            axisLabel: {
              color: '#ffffff',
              fontSize: 16
            },
            splitLine: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#7f8fa4'
              }
            }
          }
        ],
        series: [
          {
            name: this.locale('Actual','实际'),
            type: 'bar',
            itemStyle: {
              normal: {
                color: '#70DF00'
              }
            },
            barWidth: 20,
            data: this.dataset[0]
          },
          {
            name: this.locale('Target','目标'),
            type: 'line',
            itemStyle: { normal: { color: '#1E90FF' } },
            barWidth: '30%',
            data: this.dataset[1],
            symbol: 'diamond'
          }
        ]
      };

      // 5：展示数据
      myChart.setOption(option);
    }
  }
};
</script>

<style lang="less" >
#bscdown1 {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: rgba(6, 30, 93, 0.5);
  // border-top: 2px solid rgba(1, 153, 209, 0.5);
  box-sizing: border-box;
  margin-right: 10px;
  .box {
    height: 100%;
    width: 100%;
  }
}
</style>
